import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerFacade } from '../../facades/customer.facade';

@Component({
  selector: 'app-remove-item-from-order-modal',
  templateUrl: './remove-item-from-order-modal.component.html',
  styleUrls: ['./remove-item-from-order-modal.component.scss'],
  standalone: false,
})
export class RemoveItemFromOrderModalComponent {
  @Input() showModalConfirmRemove: boolean = false;
  @Input() deleteLastItemAndDeclineOrderFlag: boolean = false;
  @Input() clickedItemDataName!: string;
  @Input() orderId!: string;
  @Output() restartShowModal: EventEmitter<object> = new EventEmitter<object>();
  @Output() removeItemFromCart: EventEmitter<any> = new EventEmitter();
  @Output() lastItemDeclineOrder: EventEmitter<any> = new EventEmitter();

  setButtonDisabledAttribute: boolean = false;
  private readonly customerFacade: CustomerFacade = inject(CustomerFacade);
  isApprover$: Observable<boolean> = this.customerFacade.isApprover();

  crossClick(): void {
    this.restartShowModal.emit({showModalConfirmRemove: false, deleteLastItemAndDeclineOrderFlag: false});
  }

  clickRemoveItemFromCart(): void {
    this.removeItemFromCart.emit();
  }

  clickDeclineOrder(): void {
    this.lastItemDeclineOrder.emit();
    this.setButtonDisabledAttribute = true;
  }
}
